import type { AxiosResponse } from 'axios';
import type { ApiResponse, Canale, PaginatedResponse } from '@offertify/core';
import { getApiClient } from '../configure';

export interface GetCanaliParams {
  page?: number;
  limit?: number;
  search?: string;
}

/** Resolve the shared transport lazily so the app can configure it at startup. */
function http() {
  return getApiClient().client;
}

/**
 * Canali domain endpoints (tenant-managed reference channels, e.g. MEPA/METRO,
 * assignable to Clienti). Platform-agnostic (web + mobile).
 */
export const canaliAPI = {
  getCanali: (params?: GetCanaliParams): Promise<AxiosResponse<PaginatedResponse<Canale>>> =>
    http().get('/canali', { params }),

  getCanaliForSelect: (): Promise<AxiosResponse<Canale[]>> => http().get('/canali/select'),

  getCanale: (id: string): Promise<AxiosResponse<Canale>> => http().get(`/canali/${id}`),

  createCanale: (data: Partial<Canale>): Promise<AxiosResponse<Canale>> =>
    http().post('/canali', data),

  updateCanale: (id: string, data: Partial<Canale>): Promise<AxiosResponse<Canale>> =>
    http().put(`/canali/${id}`, data),

  // Hard-deletes ClienteCanaleLink rows first, then the Canale itself.
  deleteCanale: (id: string): Promise<AxiosResponse<ApiResponse<void>>> =>
    http().delete(`/canali/${id}`),
};
